import { mapListedCategoryApiData } from 'connectors/categories/Categories';
import { useCatalogQueryApi } from 'graphql/generated';
import { useQueryError } from 'hooks/graphQl/UseQueryError';
import { useMemo } from 'react';
import { ListedCategoryType } from 'types/category';

export function useCatalog(): ListedCategoryType[] | undefined {
    const [{ data, error }] = useCatalogQueryApi();
    useQueryError(error);

    return useMemo(
        () =>
            data?.categories.map((category) => {
                return {
                    totalCount: category.productsCount,
                    ...mapListedCategoryApiData(category),
                };
            }),
        [data?.categories],
    );
}
